module.exports = __webpack_public_path__ + "img/tjremark.0e10f32a.png";